export default ({ request }) => ({
    ecomPlatformSubsOrderEvnetLogsListApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/platform/subs/order/eventlogs/list',
        method: 'POST',
        data,
      })
    },
    ecomPlatformSubsOrderEvnetLogsDetailApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/platform/subs/order/eventlogs/detail',
        method: 'POST',
        data,
      })
    },
    ecomPlatformSubsOrderEvnetLogsRetryApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/platform/subs/order/eventlogs/retry',
        method: 'POST',
        data,
      })
    },
    ecomPlatformSubsOrderEvnetLogsSendMessageApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/platform/subs/order/eventlogs/sendMessage',
        method: 'POST',
        data,
      })
    },
})